import type {
  SelectOption,
  RevTabsType,
  RevRadioOption,
} from "@revmatics/catalyst";

export const genderRadioOptions: RevRadioOption[] = [
  { value: "All", label: "All" },
  { value: "Men", label: "Men" },
  { value: "Women", label: "Women" },
];

export const educationOptions: SelectOption[] = [
  { value: "High School", label: "High School" },
  { value: "Associate's Degree", label: "Associate's Degree" },
  { value: "Bachelor's Degree", label: "Bachelor's Degree" },
  { value: "Master's Degree", label: "Master's Degree" },
  {
    value: "Doctorate",
    label: "Doctorate",
  },
  { value: "Other", label: "Other" },
];

export const occupationOptions: SelectOption[] = [
  { value: "Student", label: "Student" },
  { value: "Self-employed", label: "Self-employed" },
  { value: "Corporate Employee", label: "Corporate Employee" },
  { value: "Military", label: "Military" },
  { value: "Freelancer", label: "Freelancer" },
  { value: "Retired", label: "Retired" },
  { value: "Other", label: "Other" },
];

export const maritalStatusOptions: RevRadioOption[] = [
  { value: "All", label: "All" },
  { value: "Single", label: "Single" },
  { value: "Married", label: "Married" },
  { value: "Divorced", label: "Divorced" },
  { value: "Widowed", label: "Widowed" },
];

export const familySizeOptions: RevRadioOption[] = [
  { value: "All", label: "All" },
  { value: "NoChildren", label: "No children" },
  { value: "OneToTwoChildren", label: "1-2 children" },
  { value: "ThreePlusChildren", label: "3+ children" },
];

export const browseMethodOptions: RevRadioOption[] = [
  { value: "All", label: "All" },
  { value: "SocialMedia", label: "Social Media" },
  { value: "OnlineSearch", label: "Online Search (amazon, google, etc)" },
  { value: "InPerson", label: "In Person (select major stores)" },
  { value: "Other", label: "Other" },
];

export const buyingMethodOptions: RevRadioOption[] = [
  { value: "All", label: "All" },
  { value: "SocialMedia", label: "Social Media" },
  { value: "OnlineSearch", label: "Online Search (amazon, google, etc)" },
  { value: "InPerson", label: "In Person (select major stores)" },
  { value: "Other", label: "Other" },
];

export const ageSelectOptions: SelectOption[] = [];
for (let i = 18; i <= 65; i++) {
  ageSelectOptions.push({ value: i.toString(), label: i.toString() });
}

export const personasListTabs: RevTabsType = [
  { id: "all", title: "All" },
  { id: "user_created", title: "User Created" },
  { id: "ai_generated", title: "AI Generated" },
];
